import { render, staticRenderFns } from "./DeleteV2Icon.vue?vue&type=template&id=575d5144&scoped=true"
import script from "./DeleteV2Icon.vue?vue&type=script&lang=js"
export * from "./DeleteV2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575d5144",
  null
  
)

export default component.exports